import { createClient } from "contentful";

const client = createClient({
    space: "jahdfmrhlzlw",
    accessToken: "jz-S_eQWGWA_5M51tCHepuaqfd-s-YSYnMwyUMc6WJQ",
    host: "preview.contentful.com",
});

function parseContentfulResponse(response) {
    return response.items.map((item) => {
        const { sys, fields } = item;

        return {
            id: sys.id,
            title: fields.title,
            slug: fields.slug,
            publicationDate: fields.publicationDate,
            body: fields.body,
            headerImage: fields.headerImage?.fields?.file?.url
                ? "https:" + fields.headerImage.fields.file.url
                : null,
            author: {
                name: fields.author.fields.name,
                bio: fields.author.fields.bio,
                profilePicture: fields.author.fields.profilePicture?.fields?.file?.url
                    ? "https:" + fields.author.fields.profilePicture.fields.file.url
                    : null,
            },
        };
    });
}

const useContentful = () => {
    const getPosts = async () => {
        try {
            const entries = await client.getEntries({
                content_type: process.env.REACT_APP_CONTENTFUL_BLOG_MODEL,
                select: "fields",
            });

            return parseContentfulResponse(entries);
        } catch (error) {
            console.error("Error fetching Contentful posts:", error);
            return [];
        }
    };

    const getPostBySlug = async (slug) => {
        try {
            const entries = await client.getEntries({
                content_type: process.env.REACT_APP_CONTENTFUL_BLOG_MODEL,
                "fields.slug": slug,
                limit: 1,
            });

            const formattedEntries = parseContentfulResponse(entries);
            return formattedEntries.length > 0 ? formattedEntries[0] : null;
        } catch (error) {
            console.error(`Error fetching post with slug "${slug}":`, error);
            return null;
        }
    };

    const getPartners = async () => {
        try {
            const entries = await client.getEntries({
                content_type: "logo",
                select: "fields",
            });
            return entries.items.map((item) => {
                const { sys, fields } = item;
                return {
                    id: sys.id,
                    name: fields.name,
                    logo: fields.logo?.fields?.file?.url
                        ? "https:" + fields.logo.fields.file.url
                        : null,
                };
            }
            );
        } catch (error) {
            console.error("Error fetching Contentful partners:", error);
            return [];
        }
    };

    return { getPosts, getPostBySlug, getPartners };
};

export default useContentful;
